/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import UiIcon from 'ui-components/ui-icon/UiIcon';
import { StyledAlertError } from './AlertError.styles';

const AlertError = ({
  error,
  title,
  description,
  unvisibleMore,
  className,
  ...props
}) => {
  const { t } = useTranslation();
  const [visibleError, setVisibleError] = useState(false);
  const [showAlert, setShowAlert] = useState(true);

  // شخصی سازی خطا
  const customError = {
    message: error?.message,
    status: error?.response?.status,
    errors:
      error?.response?.data?.errors?.data || error?.response?.data?.errors,
  };

  return (
    showAlert && (
      <StyledAlertError>
        <div
          className={classNames('alert-error', className)}
          data-testid={props?.['data-testid'] || 'alert-error'}
        >
          <div className='flex center'>
            <UiIcon
              icon='ri-close-line'
              color='#F16063'
              onClick={() => setShowAlert(false)}
            />
            <div className='flex-1 pr-24'>
              <div className='bold'>
                {title ||
                  t('common:errorOccurred', { status: customError?.status })}
              </div>
              {/* <span>{customError?.message}</span> */}
              {description && <div>{description}</div>}
              {!unvisibleMore && (
                <span
                  className='more-details'
                  onClick={() => setVisibleError((x) => !x)}
                >
                  {t('common:showDetails')}
                </span>
              )}
            </div>
          </div>
          {visibleError && (
            <>
              {customError?.errors?.message ? (
                <div
                  style={{
                    overflow: 'hidden',
                    marginTop: 20,
                    userSelect: 'text',
                    color: 'red',
                  }}
                >
                  <div>
                    <span className='bold'>{t('common:errorText')}: </span>
                    <span>{customError?.errors?.message}</span>
                  </div>
                  <div>
                    <span className='bold'>{t('common:errorCode')}: </span>
                    <span>{customError?.errors?.status_code}</span>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    overflow: 'hidden',
                    marginTop: 20,
                    userSelect: 'text',
                    color: 'red',
                  }}
                >
                  {(customError?.errors?.errors || customError?.errors) &&
                    Object?.entries(
                      customError?.errors?.errors || customError?.errors
                    ).map((item, idx) => (
                      <div key={`item-${idx}`} className='mb-10'>
                        <div>
                          <span className='bold'>
                            {t('common:errorOf', { status: idx + 1 })}:{' '}
                          </span>
                          <bdi>{item[0]}</bdi>
                        </div>
                        <div>
                          <span className='bold'>
                            {t('common:errorText')}:{' '}
                          </span>
                          <bdi>{item[1][0]}</bdi>
                        </div>
                      </div>
                    ))}
                  <div>
                    <span className='bold'>{t('common:errorCode')}: </span>
                    <span>{customError?.errors?.status_code}</span>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </StyledAlertError>
    )
  );
};
// یا آبجکت پاس داده میشه یا عنوان و توضیحات ارور
AlertError.propTypes = {
  error: PropTypes.object,
  title: PropTypes.string,
  description: PropTypes.string,
  unvisibleMore: PropTypes.bool,
  className: PropTypes.string,
};

export default AlertError;
